module.exports = __webpack_public_path__ + "static/media/INFURA_API_KEY.327c5bc1.bin";


//////////////////
// WEBPACK FOOTER
// ./src/INFURA_API_KEY
// module id = 600
// module chunks = 0